import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Constants from "../../Constants";
import { FiUnlock } from "react-icons/fi";
const LazyUpdateThumb = ({ item }) => {
  const minutes = Math.floor(item.video_duration / 60);
  const seconds = item.video_duration - minutes * 60;
  const [showVideoThumb, setShowVideoThumb] = useState(false);
  const showThumb = () => {
    setShowVideoThumb(true);
  };
  const mobileShowThumb = () => {
    setShowVideoThumb(true);
    setTimeout(() => {
      setShowVideoThumb(false);
    }, 9200);
  };
  const hideThumb = () => {
    setShowVideoThumb(false);
  };
  return (
    <div className="thumb" key={`recentupdates${item.id}`}>
      <div className={`th ${item.site.short_name}`}>
        <div
          className="wrap_image"
          onTouchStart={item.has_ma_preview === "y" ? mobileShowThumb : null}
          onMouseOut={item.has_ma_preview === "y" ? hideThumb : null}
          onMouseOver={item.has_ma_preview === "y" ? showThumb : null}
          onTouchMove={item.has_ma_preview === "y" ? mobileShowThumb : null}
        >
          <Link to={`${Constants.HOME}video/${item.id}`}>
            <LazyLoadImage
              alt={item.short_title}
              height={225}
              src={`${Constants.STATIC}${item.featured_image.thumb_name}`}
              width={400}
            />
          </Link>
          <div className="time">
            {minutes}:{seconds > 9 ? seconds : `0${seconds}`}
          </div>
          {item.site_id === 8 ? (
            <div className="rate unlocked">
              <FiUnlock style={{ marginRight: 5 }} />
              UNLOCKED
            </div>
          ) : (
            <div className="rate">
              <i className="icon-like"></i>
              <span>
                {Math.ceil(
                  (item.up_votes / (item.up_votes + item.down_votes)) * 100,
                )}
                %
              </span>
            </div>
          )}

          {showVideoThumb ? (
            <div className="video-thumbnail">
              <Link
                to={`${Constants.HOME}video/${item.id}`}
                dangerouslySetInnerHTML={{
                  __html: `<video
                        src="${Constants.VIDEO_PREVIEWS}${item.id}.mp4"
                        muted
                        loop
                        playsinline
                        preload="auto"
                        autoplay
                      ></video>`,
                }}
              ></Link>
            </div>
          ) : null}
        </div>
        <div className="tools">
          {item.models.map((model, index) => {
            if (index === item.models.length - 1) {
              return (
                <div className="name" key={`mu${item.id}-${model.id}`}>
                  <Link
                    to={`${
                      Constants.HOME
                    }girl/${model.model_name.toLowerCase()}/${model.id}`}
                  >
                    {model.model_name}
                  </Link>
                </div>
              );
            }
            return (
              <div className="name" key={`mu${item.id}-${model.id}`}>
                <Link
                  to={`${
                    Constants.HOME
                  }girl/${model.model_name.toLowerCase()}/${model.id}`}
                >
                  {model.model_name},{" "}
                </Link>
              </div>
            );
          })}

          <div className="date">{item.release_date}</div>
          <div className="site_source">
            <Link to={`${Constants.HOME}${item.site.site_slug}`}>
              {item.site.short_name.toUpperCase()}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LazyUpdateThumb;
